import { TimesheetSettingsType } from 'api/customer/types';
import { Timesheet, TimesheetTemplate } from 'api/report/types';

export const hasSickHours = (
    timesheet: Timesheet,
    setting: TimesheetSettingsType
): boolean => {
    const days = timesheet.days ?? [];
    for (let i = 0; i < days.length; i++) {
        const day = days[i];
        if (setting === TimesheetSettingsType.NORMAL) {
            if (day.sickHours && day.sickHours.length > 0) {
                return true;
            }
        } else if (setting === TimesheetSettingsType.START_STOP_TIME) {
            if (day.intervals) {
                for (let j = 0; j < day.intervals.length; j++) {
                    const interval = day.intervals[j];
                    if (interval.isSickHours) {
                        return true;
                    }
                }
            }
        }
    }

    return false;
};

export const addSickHours = (
    timesheet: Timesheet,
    templateData: TimesheetTemplate,
    setting: TimesheetSettingsType
): Timesheet => {
    const count = templateData.subheader?.length ?? 0;

    return {
        ...timesheet,
        days: (timesheet.days ?? []).map(day => {
            if (setting === TimesheetSettingsType.NORMAL) {
                const current = day.sickHours;
                const diff = Math.max(count - current.length, 0);
                return {
                    ...day,
                    sickHours: [...current, ...Array<string>(diff).fill('')],
                };
            }

            if (day.intervals[1]) {
                return day;
            }
            return {
                ...day,
                intervals: [
                    day.intervals[0] ?? {
                        start: '',
                        stop: '',
                        breakInMinutes: 0,
                        isSickHours: false,
                    },
                    {
                        start: '',
                        stop: '',
                        breakInMinutes: 0,
                        isSickHours: true,
                    },
                ],
            };
        }),
    };
};
